<div class="h-100 w-100 d-flex flex-column flex-grow-1 overflow-auto printnode-dialog-root" [dir]="isRTL ? 'rtl' : 'ltr'">

  <div class="position-absolute w-100 d-flex zx-z-index-1" [class.justify-content-end]="isRTL">
    <button type="button" mat-icon-button aria-label="Close" (click)="closeDialog()"
      class="close-icon d-flex align-items-center justify-content-center" [class.text-white]="isDarkMode">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="d-flex flex-grow-1 flex-column px-3 pt-4 pb-3 px-md-4 pt-md-4 gap-3 w-100 position-relative printnode-dialog-body">

    <h4 class="text-center fw-bold m-0 pt-3 pt-lg-0" [class.text-white]="isDarkMode">
      {{ "su-management.printnode-dialog-title" | translate }}
    </h4>

    <p *ngIf="orderId" class="text-center zx-text-small m-0 opacity-75" [class.text-white]="isDarkMode" [class.zx-ltr]="!isRTL">
      {{ "su-management.printnode-dialog-order-label" | translate }}: <span class="fw-semibold">{{ orderId }}</span>
    </p>

    <ng-container *ngIf="!viewModel.isEmpty">

      <!-- מדפסת ומחשב -->
      <div *ngIf="viewModel.printer" class="printnode-panel w-100 rounded-3 p-3"
        [class.printnode-panel--dark]="isDarkMode">
        <div class="d-flex align-items-start gap-2 flex-wrap">
          <mat-icon class="printnode-section-ico flex-shrink-0" [class.text-white]="isDarkMode">print</mat-icon>
          <div class="flex-grow-1 min-w-0">
            <div class="d-flex align-items-center gap-2 flex-wrap mb-1">
              <span class="fw-bold" [class.text-white]="isDarkMode">{{ viewModel.printer.displayName }}</span>
              <span class="printnode-pill" [class.printnode-pill--ok]="viewModel.printer.healthy"
                [class.printnode-pill--warn]="!viewModel.printer.healthy">
                <mat-icon class="printnode-pill-ico">{{ viewModel.printer.healthy ? 'verified' : 'warning_amber' }}</mat-icon>
                {{ (viewModel.printer.healthy ? "su-management.printnode-dialog-chain-ok" : "su-management.printnode-dialog-chain-issue") | translate }}
              </span>
            </div>
            <div class="d-flex flex-column gap-1 zx-text-small" [class.text-white]="isDarkMode" [class.opacity-90]="isDarkMode">
              <div class="d-flex flex-wrap align-items-center gap-2">
                <span class="printnode-kv-label">{{ "su-management.printnode-dialog-printer-state" | translate }}:</span>
                <span class="fw-semibold">{{ printerStateLabel(viewModel.printer.printerStateRaw) }}</span>
              </div>
              <div class="d-flex flex-wrap align-items-center gap-2">
                <span class="printnode-kv-label">{{ "su-management.printnode-dialog-computer-state" | translate }}:</span>
                <span class="fw-semibold">{{ computerStateLabel(viewModel.printer.computerStateRaw) }}</span>
              </div>
              <div *ngIf="viewModel.printer.hostname" class="d-flex flex-wrap align-items-center gap-2 zx-ltr">
                <span class="printnode-kv-label">{{ "su-management.printnode-dialog-hostname" | translate }}:</span>
                <span class="fw-semibold">{{ viewModel.printer.hostname }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- קבצים -->
      <div class="w-100">
        <div class="d-flex align-items-center gap-2 mb-2 px-1">
          <mat-icon class="printnode-section-ico-sm" [class.text-white]="isDarkMode">description</mat-icon>
          <span class="fw-bold zx-text-small" [class.text-white]="isDarkMode">
            {{ "su-management.printnode-dialog-files-section" | translate }}
          </span>
        </div>

        <div *ngFor="let f of viewModel.files" [ngClass]="fileRowClass(f)" class="mb-2"
          [class.printnode-file-row-dark]="isDarkMode">
          <div class="d-flex gap-2 align-items-start">
            <mat-icon [ngClass]="fileIconClass(f)" class="flex-shrink-0">{{ fileIcon(f) }}</mat-icon>
            <div class="flex-grow-1 min-w-0">
              <div class="fw-bold" [class.text-white]="isDarkMode">{{ f.fileName }}</div>
              <div class="zx-text-small mt-1" [class.opacity-90]="isDarkMode" [class.text-white]="isDarkMode">
                <span class="printnode-kv-label">{{ "su-management.printnode-dialog-job-state" | translate }}:</span>
                {{ jobStateLabel(f.jobStateRaw) }}
                <span *ngIf="outcomeHint(f.outcome)" class="opacity-75"> — {{ outcomeHint(f.outcome) }}</span>
              </div>
              <div *ngIf="f.remoteId" class="zx-text-small mt-1 opacity-75 zx-ltr" [class.text-white]="isDarkMode">
                {{ "su-management.printnode-dialog-remote-id" | translate }}: {{ f.remoteId }}
              </div>
              <div *ngIf="f.lastDetail" class="printnode-detail zx-text-small mt-2" [class.text-white]="isDarkMode">
                {{ f.lastDetail }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <div *ngIf="viewModel.isEmpty" class="text-center py-3" [class.text-white]="isDarkMode">
      {{ "su-management.printnode-snack-empty" | translate }}
    </div>

    <div class="d-flex justify-content-center pt-2 pb-1 w-100">
      <button type="button" mat-raised-button color="primary" (click)="closeDialog()"
        class="rounded-pill px-4 fw-bold text-white printnode-close-btn">
        {{ "error-content-ok-btn" | translate }}
      </button>
    </div>
  </div>
</div>
